<template>
  <form action="" method="post">
    <div class="p-contactHead">
      <ul class="p-contactHead__process">
        <li :class="{'isCurrent': state === 'form'}">必須項⽬の⼊⼒</li>
        <li :class="{'isCurrent': state === 'confirm'}">⼊⼒内容の確認</li>
        <li :class="{'isCurrent': state === 'complete'}">送信完了</li>
      </ul>
    </div>

    <transition name="p-contactFrm">
    <div v-if="state === 'form'" class="p-contactFrm">
      <div class="p-contactFrm__input p-contactFrm__input--half" :class="{'p-contactFrm__input--error': errors['contactType']}">
        <div class="p-contactFrm__inputWrap">
          <label for="contact-type">
            <span v-show="contactType === ''" class="isRequired">職種を選択してください</span>
          </label>
          <p class="p-contactFrm__inputWrap__selectValue">{{contactType}}</p>
          <div class="p-contactFrm__inputWrap__btn">
            <span class="p-contactFrm__inputWrap__btnArrow"></span>
          </div>
          <select id="contact-type" v-model="contactType" name="contact-type">
            <option value=""></option>
            <option v-for="(val, index) in params" :value="val">{{val}}</option>
          </select>
        </div>
        <p v-show="errors['contactType']" class="p-contactFrm__inputError">{{errors['contactType']}}</p>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half" :class="{'p-contactFrm__input--error': errors['name']}">
        <div class="p-contactFrm__inputWrap">
          <label for="input-name">
            <span v-show="showPlaceholder('name')" class="isRequired">お名前</span>
          </label>
          <input id="input-name" v-model="name" type="text" name="name" @focus="inputFocus('name')" @blur="inputBlur('name')" />
        </div>
        <p v-show="errors['name']" class="p-contactFrm__inputError">{{errors['name']}}</p>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half" :class="{'p-contactFrm__input--error': errors['email']}">
        <div class="p-contactFrm__inputWrap">
          <label for="input-email">
            <span v-show="showPlaceholder('email')" class="isRequired">メールアドレス</span>
          </label>
          <input id="input-email" v-model="email" type="email" name="email" @focus="inputFocus('email')" @blur="inputBlur('email')" />
        </div>
        <p v-show="errors['email']" class="p-contactFrm__inputError">{{errors['email']}}</p>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half" :class="{'p-contactFrm__input--error': errors['tel']}">
        <div class="p-contactFrm__inputWrap">
          <label for="input-tel">
            <span v-show="showPlaceholder('tel')" class="isRequired">電話番号</span>
          </label>
          <input id="input-tel" v-model="tel" type="text" name="tel" @focus="inputFocus('tel')" @blur="inputBlur('tel')" />
        </div>
        <p v-show="errors['tel']" class="p-contactFrm__inputError">{{errors['tel']}}</p>
      </div>

      <div class="p-contactFrm__input">
        <div class="p-contactFrm__inputWrap p-contactFrm__inputWrap--ta">
          <label for="textarea-message">
            <span v-show="showPlaceholder('message')">自由記入欄（作品URLなどがある方はこちらへご記入ください）</span>
          </label>
          <textarea id="textarea-message" v-model="message" name="message" @focus="inputFocus('message')" @blur="inputBlur('message')"></textarea>
        </div>
        <p v-show="errors['message']" class="p-contactFrm__inputError">{{errors['message']}}</p>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--center">
        <div class="c-btnAttached">
          <span class="c-btnAttached__text">添付ファイル</span>
          <svg class="c-btnAttached__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14" width="15" height="14">
            <path d="M1.106,12.522 C-0.400,11.006 -0.386,9.625 1.106,8.122 L7.694,1.489 C9.684,-0.514 11.480,-0.499 13.488,1.523 C15.496,3.544 15.511,5.352 13.521,7.355 L6.933,13.989 L6.204,13.255 L12.759,6.656 C14.252,5.153 14.265,3.772 12.759,2.256 C11.253,0.740 9.882,0.753 8.389,2.256 L1.834,8.856 C0.839,9.857 0.830,10.778 1.834,11.789 C2.838,12.799 3.753,12.790 4.748,11.789 L11.303,5.189 C11.800,4.688 11.805,4.228 11.303,3.722 C10.801,3.217 10.343,3.222 9.846,3.722 L3.291,10.322 L2.563,9.589 L9.118,2.989 C10.112,1.988 11.027,1.978 12.031,2.989 C13.035,4.000 13.026,4.921 12.031,5.922 L5.476,12.522 C3.984,14.024 2.612,14.038 1.106,12.522 Z"/>
          </svg>
          <input ref="attachedFile" type="file" name="attached-file" @change="attachedFile">
        </div>
        <div class="p-contactFrm__inputNotice p-contactFrm__inputNotice--center">
          <p v-if="!fileName">添付可能な拡張⼦ ZIP PDF XLS XLSX</p>
          <p v-if="fileName">{{fileName}}<span class="is-delete" @click="deleteFile">削除する</span></p>
        </div>
        <p v-show="errors['file']" class="p-contactFrm__inputError">{{errors['file']}}</p>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--agree" :class="{'p-contactFrm__input--error': errors['agree']}">
        <div class="p-contactFrm__agree">
          <input id="input-agree" v-model="agree" type="checkbox" name="agree">
          <label @click="checkAgree">
            <span class="p-contactFrm__agree__check" :class="{'isChecked': this.agree}"></span>
            <span class="p-contactFrm__agree__text">「<a :href="`${assets_path}pdf/pp-recruit.pdf`" target="_blank">個人情報の取り扱いについて</a>」をご確認頂き、同意の上エントリーください。</span>
          </label>
        </div>
        <p v-show="errors['agree']" class="p-contactFrm__inputError p-contactFrm__inputError--center">{{errors['agree']}}</p>
      </div>

      <div class="p-contactFrm__btnOuter">
        <div class="p-contactFrm__btn">
          <btn-submit
            textEn="CONFIRM"
            textJa="送信内容を確認する"
            bgColor="white"
            @click.native="onConfirm"
          >
          </btn-submit>
        </div>
      </div>
    </div>

    <div v-if="state === 'confirm'" class="p-contactFrm">
      <div class="p-contactFrm__input p-contactFrm__input--half">
        <dl class="p-contactFrm__inputResult">
          <dt>職種を選択してください</dt>
          <dd>{{contactType}}</dd>
        </dl>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half">
        <dl class="p-contactFrm__inputResult">
          <dt>お名前</dt>
          <dd>{{name}}</dd>
        </dl>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half">
        <dl class="p-contactFrm__inputResult">
          <dt>メールアドレス</dt>
          <dd>{{email}}</dd>
        </dl>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half">
        <dl class="p-contactFrm__inputResult">
          <dt>電話番号</dt>
          <dd>{{tel}}</dd>
        </dl>
      </div>

      <div class="p-contactFrm__input">
        <dl class="p-contactFrm__inputResult">
          <dt>自由記入欄（作品URLなどがある方はこちらへご記入ください）</dt>
          <dd><pre>{{message}}</pre></dd>
        </dl>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--bottom">
        <dl class="p-contactFrm__inputResult">
          <dt>添付ファイル</dt>
          <dd>{{fileName}}<span v-if="!fileName">なし</span></dd>
        </dl>
      </div>

      <div class="p-contactFrm__btn">
        <div class="p-contactFrm__btnBack">
          <btn-submit
            textEn="BACK"
            textJa="戻る"
            bgColor="black"
            @click.native="onBack"
          >
          </btn-submit>
        </div>
        <div class="p-contactFrm__btnSubmit">
          <btn-submit
            textEn="ENTRY"
            textJa="送信する"
            bgColor="white"
            @click.native="onSubmit"
          >
          </btn-submit>
        </div>
      </div>
    </div>

    <div v-if="state === 'complete'" class="p-contactComp">
      <h1>ご応募いただきありがとうございす。<br />エントリーを受け付けました。</h1>
      <p>折り返し、担当者よりご連絡いたしますので、<br />恐れ入りますが、しばらくお待ちください。</p>
      <p>なお、ご入力いただいたメールアドレス宛に受付完了メールを配信しております。<br />完了メールが届かない場合、処理が正常に行われていない可能性があります。<br />大変お手数ですが、再度お問い合わせの手続きをお願い致します。</p>
      <div class="p-contactComp__btn">
        <btn-square
          text="TOPページ"
          url="/"
          bgColor="black"
        ></btn-square>
      </div>
    </div>
    </transition>
  </form>
</template>

<script>
import { assets_path } from '@/_modules/utils/variables'
import axios from 'axios';
import store from '@/_modules/stores';
import BtnSubmit from '@/_components/btn-submit.vue';
import BtnSquare from '@/_components/btn-square.vue';
import validator from 'validator';
import {gsap, TweenMax, Cubic, ScrollToPlugin} from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin);

export default {
  components: {
    BtnSubmit,
    BtnSquare
  },
  data() {
    return {
      assets_path: assets_path,
      state: 'form',
      isSubmit: false,
      params: [],
      errorFlg: false,
      errors: {},
      placeholder: {
        contactType: false,
        name: false,
        email: false,
        tel: false,
        message: false,
      },
      contactType: '',
      name: '',
      email: '',
      tel: '',
      message: '',
      file: null,
      fileName: '',
      agree: false,
      compUrl: '/recruit-form-complete/'
    }
  },
  store,
  computed: {
    showPlaceholder: function() {
      return function(name) {
        return !this.placeholder[name];
      }
    }
  },
  created() {
  },
  mounted() {
    this.params = JSON.parse(document.getElementById('js-param-recruit').textContent);
  },
  methods: {
    onConfirm() {

      // エラー情報をリセット
      this.errorFlg = false;
      this.errors = {
        contactType: '',
        name: '',
        email: '',
        tel: '',
        message: '',
        agree: '',
        file: '',
      };

      // 職種
      if (validator.isEmpty(this.contactType, {ignore_whitespace: true})) {
        // 未入力
        this.errorFlg = true;
        this.errors['contactType'] = '職種を選択してください';
      }

      // お名前
      if (validator.isEmpty(this.name, {ignore_whitespace: true})) {
        // 未入力
        this.errorFlg = true;
        this.errors['name'] = 'お名前が入力されていません';
      } else if (!validator.isLength(this.name, {min: 0, max: 100})) {
        // 文字数超え
        this.errorFlg = true;
        this.errors['name'] = 'お名前は100文字以下で入力してください';
      }

      // メールアドレス
      if (validator.isEmpty(this.email, {ignore_whitespace: true})) {
        // 未入力
        this.errorFlg = true;
        this.errors['email'] = 'メールアドレスが入力されていません';
      } else if (!validator.isEmail(this.email)) {
        // メールアドレスが正しくない
        this.errorFlg = true;
        this.errors['email'] = 'メールアドレスが正しくありません';
      } else if (!validator.isLength(this.email, {min: 0, max: 1000})) {
        // 文字数超え
        this.errorFlg = true;
        this.errors['email'] = 'メールアドレスは1000文字以下で入力してください';
      }

      // 電話番号
      if (validator.isEmpty(this.tel, {ignore_whitespace: true})) {
        // 未入力
        this.errorFlg = true;
        this.errors['tel'] = '電話番号が入力されていません';
      } else if (!validator.isLength(this.tel, {min: 0, max: 30})) {
        // 文字数超え
        this.errorFlg = true;
        this.errors['tel'] = '電話番号は30文字以下で入力してください';
      }

      // 自由記入欄（作品URLなどがある方はこちらへご記入ください）
      if (!validator.isEmpty(this.message, {ignore_whitespace: true})) {
        if (!validator.isLength(this.message, {min: 0, max: 5000})) {
          // 文字数超え
          this.errorFlg = true;
          this.errors['message'] = '自由記入欄は5000文字以下で入力してください';
        }
      }

      // 添付ファイル
      if (!this.isEmptyFile()) {
        if (this.isSizeFile()) {
          // 文字数超え
          this.errorFlg = true;
          this.errors['file'] = '添付ファイルは10MB以下にしてください';
        }
      }

      // 同意
      if (!this.agree) {
        // 未入力
        this.errorFlg = true;
        this.errors['agree'] = '「個人情報の取り扱いについて」をご確認頂き、同意の上エントリーください。';
      }

      // 上にスクロール
      this.gotoHead();

      if (!this.errorFlg) {
        this.state = 'confirm';
      }
    },
    onBack() {
      this.gotoHead();
      this.state = 'form';
    },
    onSubmit() {
      // ajax送信 /////
      const siteDomain = location.hostname;
      const index = this.$store.getters.getDomains.findIndex(item => item === siteDomain);

      if (this.isSubmit) return;
      this.isSubmit = true;

      if (index > -1) {
        // multipart/form-data形式のため、new FormData()を使う
        const data = new FormData();
        data.append('mode', 'send');
        data.append('recruit_job', this.contactType);
        data.append('recruit_name', this.name);
        data.append('recruit_email', this.email);
        data.append('recruit_tel', this.tel);
        data.append('recruit_url', this.message);
        data.append('recruit_file', this.file);

        const pg = location.protocol + '//' + siteDomain + '/pg-recruit/';

        axios.post(pg, data)
          .then(this.complete)
          .catch(this.onError);
      } else {
        // 開発用
        this.complete();
      }
      //////////
    },
    complete(e) {
      //console.log('コンプリート', e);
      //this.gotoHead();
      //this.state = 'complete';
      this.$parent.$refs['TransitionCover'].coverIn(this.compUrl);
    },
    onError(error) {
      this.isSubmit = false;
      console.log(error);
    },
    inputFocus(name) {
      this.placeholder[name] = true;
    },
    inputBlur(name) {
      if (this[name]) {
        this.placeholder[name] = true;
      } else {
        this.placeholder[name] = false;
      }
    },
    deleteFile() {
      this.file = '';
      this.fileName = '';
      this.$refs['attachedFile'].value = '';
    },
    attachedFile(e) {
      //this.file = e;
      // 表示用
      const files = e.target.files || e.dataTransfer.files;

      if (files[0]) {
        this.file = files[0];
        this.fileName = files[0].name;
      } else {
        this.deleteFile();
      }
    },
    isEmptyFile() {
      if (!this.file) {
        return true;
      } else {
        return false;
      }
    },
    isSizeFile() {
      //const files = this.file.target.files || this.file.dataTransfer.files;
      if (this.getByte2MB(this.file.size) >= 11) {
        return true;
      } else {
        return false;
      }
    },
    checkAgree() {
      if (this.agree) {
        this.agree = false;
      } else {
        this.agree = true;
      }
    },
    gotoHead() {
      const posY = document.getElementById('p-contactMv').getBoundingClientRect().height;

      TweenMax.to(window, 0.4, {
        scrollTo:{
          y: posY,
          autoKill: false
        },
        ease: Cubic.easeOut}
      );
    },
    getByte2MB(size) {
      // 小数点第2位は切り捨て
      //file_size = Math.floor(file_size * 100) / 100;
      return (size / 1024) / 1024;
    }
  }
}
</script>
